import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthStore } from '@auth/store/auth.store';
import { waitUntilPredicate } from '@auth/utils/wait-until-predicate.utils';

/**
 * Guard to prevent access to login page when already authenticated
 */
export const loginGuard: CanActivateFn = async () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  try {
    await waitUntilPredicate(() => !authStore.isLoading());
  } catch {
    return true;
  }

  if (authStore.isAuthenticated()) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
